import React, { useState, useEffect, useRef } from "react";
import "./ValentineApp.css";
import img1 from "./img.jpeg";
import img2 from "./logo.svg";
import loveVideo from "./love.mp4";
import ImagePopup from "./ImageBrust";

const ValentineApp = () => {
  const [firstWord, setFirstWord] = useState("");
  const [secondWord, setSecondWord] = useState("");
  const [showImages, setShowImages] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showCard, setShowCard] = useState(true);
  const [videoStage, setVideoStage] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const [showImagePopup, setShowImagePopup] = useState(false); // New state

  const videoRef = useRef(null);
  const options = ["puppy", "dhaniya", "you", "cupcake", "pudina"];
  const imageSources = [img1, img2];

  useEffect(() => {
    if (
      (firstWord === "dhaniya" && secondWord === "pudina") ||
      (firstWord === "pudina" && secondWord === "dhaniya")
    ) {
      setShowImages(true);
      setShowCard(false);
      setTimeout(() => {
        setShowPopup(true);
        playVideo();
      }, 1000);
    } else {
      setShowImages(false);
      setShowPopup(false);
      setShowCard(true);
      setVideoStage(0);
      setShowImagePopup(false); // Reset when the card is visible
    }
  }, [firstWord, secondWord]);

  const playVideo = () => {
    if (videoRef.current) {
      setShowButtons(false);
      videoRef.current.play();
    }
  };

  const handleVideoUpdate = () => {
    if (videoRef.current) {
      const time = videoRef.current.currentTime;
      if (time >= 6 && videoStage === 0) {
        pauseVideo(1);
      } else if (time >= 8 && videoStage === 1) {
        pauseVideo(2);
      } else if (time >= 12 && videoStage === 2) {
        pauseVideo(3);
      } else if (time >= 16 && videoStage === 3) {
        setShowImagePopup(true); // Trigger ImagePopup at 17 seconds
      }
    }
  };

  const pauseVideo = (stage) => {
    videoRef.current.pause();
    setShowButtons(true);
    setVideoStage(stage);
  };

  const handleButtonClick = () => {
    setShowButtons(false);
    playVideo();
  };

  return (
    <div className="container">
      {showCard && (
        <div className="card">
          <h2>💕 Fill in the blanks 💕</h2>
          <h1>
            <select
              value={firstWord}
              onChange={(e) => setFirstWord(e.target.value)}
              className="select-box"
            >
              <option value="" disabled hidden>
                Choose...
              </option>
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            &nbsp;and&nbsp;
            <select
              value={secondWord}
              onChange={(e) => setSecondWord(e.target.value)}
              className="select-box"
            >
              <option value="" disabled hidden>
                Choose...
              </option>
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            &nbsp;= us ❤️
          </h1>
          <p>Combine the words 🌸</p>
        </div>
      )}
      {showPopup && (
        <div className="popup">
          <div className="video-box">
            <video
              ref={videoRef}
              width="100%"
              height="auto"
              controls={false}
              autoPlay
              onTimeUpdate={handleVideoUpdate}
            >
              <source src={loveVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {showButtons && (
            <div className="popup-buttons">
              {videoStage === 1 && (
                <>
                  <button
                    type="button"
                    className="popup-button btn"
                    onClick={handleButtonClick}
                  >
                    <strong>Huh</strong>
                    <div id="container-stars">
                      <div id="stars"></div>
                    </div>

                    <div id="glow">
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="popup-button btn"
                    onClick={handleButtonClick}
                  >
                    <strong>What?</strong>
                    <div id="container-stars">
                      <div id="stars"></div>
                    </div>

                    <div id="glow">
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </button>
                </>
              )}
              {videoStage === 2 && (
                <>
                  <button
                    type="button"
                    className="popup-button btn"
                    onClick={handleButtonClick}
                  >
                    <strong> Yes I love you</strong>
                    <div id="container-stars">
                      <div id="stars"></div>
                    </div>

                    <div id="glow">
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="popup-button no-move"
                    onClick={handleButtonClick}
                    disabled
                  >
                    <strong> No</strong>
                  </button>
                </>
              )}
              {videoStage === 3 && (
                <>
                  <button
                    type="button"
                    className="popup-button btn"
                    onClick={handleButtonClick}
                  >
                    <strong> Yes Yes Yes</strong>
                    <div id="container-stars">
                      <div id="stars"></div>
                    </div>

                    <div id="glow">
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="popup-button no-move"
                    onClick={handleButtonClick}
                    disabled
                  >
                    <strong> No No No</strong>
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      )}
      {showImagePopup && <ImagePopup />} {/* Show ImagePopup at 17 seconds */}
    </div>
  );
};

export default ValentineApp;
